var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.55 598.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dceaf5;}.cls-2{fill:#509e70;}.cls-3{fill:#9eccb3;}.cls-4{fill:#796e33;}.cls-5{fill:#3c3b3b;}.cls-6{fill:none;stroke:#33516c;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.06,598H403.9a571.72,571.72,0,0,0,91.6-310.8h.05C495.55,128.6,367,0,208.32,0A286.4,286.4,0,0,0,0,89.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.26,286.47a79.55,79.55,0,1,0-159.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.71,366a79.56,79.56,0,0,0,79.55-79.55H180.71S180.38,316.52,180.71,366Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.86,339.51a3.18,3.18,0,0,0,4.55,0L160,327.87a3.22,3.22,0,0,0-4.55-4.55l-6.15,6.26V305.11a3.19,3.19,0,0,0-6.37,0v24.47l-6.22-6.21h0a3.22,3.22,0,1,0-4.55,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.06,346.76H130.21a3.19,3.19,0,0,0,0,6.36h31.85a3.19,3.19,0,0,0,0-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.69,263.7v20.6h-4.77v-8.44h-9.35v8.44H195.8V263.7h4.77v8.12h9.35V263.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M235.52,280.48v3.82H219.58V263.7h15.56v3.83H224.31V272h9.57v3.71h-9.57v4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.44,284.3l-4-5.74h-4.38v5.74h-4.77V263.7h8.92a11.43,11.43,0,0,1,4.75.92,7,7,0,0,1,3.1,2.58,7.13,7.13,0,0,1,1.09,4,6.71,6.71,0,0,1-4.24,6.5l4.62,6.62Zm-1.2-15.79a5.08,5.08,0,0,0-3.27-.92h-3.88v7.18H248a5,5,0,0,0,3.27-.94,3.72,3.72,0,0,0,0-5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.07,284.3l-4-5.74h-4.38v5.74H261V263.7h8.91a11.45,11.45,0,0,1,4.76.92,6.8,6.8,0,0,1,4.19,6.56,6.71,6.71,0,0,1-4.24,6.5l4.62,6.62Zm-1.2-15.79a5.08,5.08,0,0,0-3.27-.92h-3.88v7.18h3.88a5,5,0,0,0,3.27-.94,3.74,3.74,0,0,0,0-5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.14,279.89h-9.56l-1.83,4.41h-4.88l9.18-20.6h4.71L303,284.3h-5Zm-1.5-3.62-3.27-7.89-3.26,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323.86,284.3l0-12.36-6.06,10.18h-2.15l-6-9.91V284.3h-4.47V263.7h3.94l7.71,12.8,7.59-12.8h3.91l.06,20.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.22,263.7H338v20.6h-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M358.82,280.48v3.82H342.87V263.7h15.56v3.83H347.61V272h9.56v3.71h-9.56v4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381.5,263.7v20.6h-3.91l-10.27-12.51V284.3h-4.71V263.7h3.94l10.25,12.51V263.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390.66,267.59h-6.6V263.7H402v3.89h-6.59V284.3h-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.11,279.89h-9.56l-1.83,4.41h-4.88L410,263.7h4.71l9.21,20.6h-5Zm-1.5-3.62-3.27-7.89-3.26,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M428.13,284a10.94,10.94,0,0,1-3.66-1.72l1.61-3.59a11,11,0,0,0,3.15,1.56,11.91,11.91,0,0,0,3.65.59,5.84,5.84,0,0,0,3-.6,1.83,1.83,0,0,0,1-1.61,1.53,1.53,0,0,0-.57-1.22,4.44,4.44,0,0,0-1.47-.78c-.6-.2-1.41-.41-2.43-.65a33.56,33.56,0,0,1-3.85-1.11,6.43,6.43,0,0,1-2.58-1.8,4.87,4.87,0,0,1-1.07-3.3,5.72,5.72,0,0,1,1-3.25,6.54,6.54,0,0,1,2.93-2.31,11.92,11.92,0,0,1,4.78-.85,16,16,0,0,1,3.85.47,11.2,11.2,0,0,1,3.3,1.35l-1.47,3.62a11.51,11.51,0,0,0-5.71-1.62,5.37,5.37,0,0,0-3,.65,2,2,0,0,0-.95,1.71,1.65,1.65,0,0,0,1.1,1.57,16.49,16.49,0,0,0,3.37,1,31.45,31.45,0,0,1,3.85,1.12,6.43,6.43,0,0,1,2.58,1.76,4.79,4.79,0,0,1,1.07,3.27,5.66,5.66,0,0,1-1,3.22,6.69,6.69,0,0,1-3,2.31,12.05,12.05,0,0,1-4.8.85A16.87,16.87,0,0,1,428.13,284Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "390.3 229.85 390.3 181.86 180.73 181.86 180.73 391.42 390.3 391.42 390.3 306.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204,295.57a4.06,4.06,0,0,1,1.71,5.79,3.82,3.82,0,0,1-1.71,1.42,6.37,6.37,0,0,1-2.61.49h-2.28v3.13h-2.63V295.07h4.91A6.36,6.36,0,0,1,204,295.57Zm-1,5.06a2,2,0,0,0,0-2.91,2.76,2.76,0,0,0-1.8-.51h-2.13v3.93h2.13A2.76,2.76,0,0,0,203,300.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215,304h-5.26l-1,2.43h-2.69l5.05-11.33h2.59l5.07,11.33H216Zm-.82-2-1.8-4.34L210.6,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.17,306.4,225,303.24h-2.41v3.16H220V295.07h4.9a6.38,6.38,0,0,1,2.62.5,3.9,3.9,0,0,1,1.71,1.43,4,4,0,0,1,.59,2.18,3.67,3.67,0,0,1-2.33,3.58L230,306.4Zm-.67-8.68a2.73,2.73,0,0,0-1.79-.51h-2.14v3.94h2.14a2.73,2.73,0,0,0,1.79-.51,1.81,1.81,0,0,0,.62-1.46A1.78,1.78,0,0,0,226.5,297.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.31,304h-5.26l-1,2.43h-2.68l5-11.33H238l5.06,11.33h-2.75Zm-.83-2-1.8-4.34L234.89,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M248.82,295.07H254a7.21,7.21,0,0,1,3.26.7,5.24,5.24,0,0,1,2.2,2,6,6,0,0,1,0,5.95,5.29,5.29,0,0,1-2.2,2,7.21,7.21,0,0,1-3.26.71h-5.15Zm5,9.18a3.81,3.81,0,0,0,2.71-.95,3.76,3.76,0,0,0,0-5.13,3.81,3.81,0,0,0-2.71-.95h-2.4v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271,304.29v2.11h-8.77V295.07h8.56v2.1H264.8v2.46h5.26v2H264.8v2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.18,306.23a6,6,0,0,1-2-1l.89-2a6.36,6.36,0,0,0,1.73.86,6.7,6.7,0,0,0,2,.32,3.24,3.24,0,0,0,1.65-.33,1,1,0,0,0,.53-.89.84.84,0,0,0-.31-.67,2.39,2.39,0,0,0-.81-.43c-.33-.1-.78-.22-1.34-.35a18.52,18.52,0,0,1-2.12-.62,3.37,3.37,0,0,1-1.41-1,2.66,2.66,0,0,1-.59-1.82,3.1,3.1,0,0,1,.53-1.78,3.62,3.62,0,0,1,1.61-1.28,6.66,6.66,0,0,1,2.63-.46,8.85,8.85,0,0,1,2.12.25,6.2,6.2,0,0,1,1.81.75l-.81,2a6.32,6.32,0,0,0-3.14-.89,3,3,0,0,0-1.62.35,1.11,1.11,0,0,0-.53.94.92.92,0,0,0,.61.87,9.77,9.77,0,0,0,1.85.56,18.15,18.15,0,0,1,2.12.61,3.64,3.64,0,0,1,1.42,1,2.65,2.65,0,0,1,.59,1.8,3.08,3.08,0,0,1-.54,1.77,3.6,3.6,0,0,1-1.63,1.27,6.49,6.49,0,0,1-2.64.47A9.31,9.31,0,0,1,274.18,306.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.67,305.84a5.63,5.63,0,0,1-2.21-2.09,6.08,6.08,0,0,1,0-6,5.63,5.63,0,0,1,2.21-2.09,6.53,6.53,0,0,1,3.14-.75,6.76,6.76,0,0,1,2.67.51,5.36,5.36,0,0,1,2,1.49l-1.68,1.56a3.59,3.59,0,0,0-2.85-1.33,3.73,3.73,0,0,0-1.87.46,3.27,3.27,0,0,0-1.29,1.29,4.05,4.05,0,0,0,0,3.75,3.27,3.27,0,0,0,1.29,1.29,3.73,3.73,0,0,0,1.87.46,3.6,3.6,0,0,0,2.85-1.34l1.68,1.55a5.26,5.26,0,0,1-2,1.51,6.76,6.76,0,0,1-2.67.51A6.49,6.49,0,0,1,285.67,305.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.47,304h-5.26l-1,2.43h-2.69l5.05-11.33h2.59l5.07,11.33h-2.75Zm-.82-2-1.8-4.34-1.8,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M314.63,306.4l-2.19-3.16H310v3.16h-2.62V295.07h4.9a6.38,6.38,0,0,1,2.62.5,3.89,3.89,0,0,1,0,7.19l2.54,3.64Zm-.67-8.68a2.75,2.75,0,0,0-1.79-.51H310v3.94h2.14a2.75,2.75,0,0,0,1.79-.51,1.81,1.81,0,0,0,.62-1.46A1.78,1.78,0,0,0,314,297.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M327,300.56h2.39v4.59a6.66,6.66,0,0,1-2.13,1.07,8.28,8.28,0,0,1-2.45.37,6.65,6.65,0,0,1-3.17-.75,5.63,5.63,0,0,1-2.21-2.09,6.08,6.08,0,0,1,0-6,5.62,5.62,0,0,1,2.23-2.09,6.77,6.77,0,0,1,3.2-.75,6.92,6.92,0,0,1,2.71.5,5.4,5.4,0,0,1,2,1.45l-1.68,1.56a3.9,3.9,0,0,0-2.93-1.28,4,4,0,0,0-1.92.45,3.23,3.23,0,0,0-1.31,1.28,3.68,3.68,0,0,0-.47,1.89,3.65,3.65,0,0,0,.47,1.88,3.29,3.29,0,0,0,1.3,1.29,3.82,3.82,0,0,0,1.9.46,4.19,4.19,0,0,0,2-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M339.24,304H334l-1,2.43h-2.69l5-11.33h2.59L343,306.4h-2.75Zm-.82-2-1.8-4.34-1.8,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.4,306.4l-2.19-3.16H346.8v3.16h-2.62V295.07h4.9a6.38,6.38,0,0,1,2.62.5,3.89,3.89,0,0,1,0,7.19l2.54,3.64Zm-.67-8.68a2.75,2.75,0,0,0-1.79-.51H346.8v3.94h2.14a2.75,2.75,0,0,0,1.79-.51,1.81,1.81,0,0,0,.62-1.46A1.78,1.78,0,0,0,350.73,297.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.a951ba84023152fdaf2fb439a1b1e30d.svg";
export { ForwardRef as ReactComponent };